import {
  Component,
  TemplateRef,
  ViewChild,
  OnInit,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { EcontentServicesService } from '../../../inputfileds/form_services/econtent-services/econtent-services.service';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { ToastService } from '../../../Services/toast/toast.service';
import { ToastComponent } from '../../../components/toast/toast.component';
import { PermissionService } from '../../../components/Authentication/services/permission.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-econtent-documents-data',
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatDialogModule,
    ReactiveFormsModule,
    DynamicFormQuestionComponent,
    ToastComponent,
    TranslateDirective
  ],
  providers: [QuestionControlService],
  templateUrl: './econtent-documents-data.component.html',
  styleUrls: ['./econtent-documents-data.component.scss']
})
export class EcontentDocumentsDataComponent implements OnInit {
  coursesId!: string;
  selectedSemester!: string;
  selectedSubject!: string;
  selectesSubjectName!: string;
  documents: any[] = [];
  questions: Inputfiledsbase<string>[] = [];
  fileToUpload: File | null = null;
  dialogRef!: MatDialogRef<any>;
  filePreview: string | null = null;
  fileName: string | null = null;
  isImage: boolean = false;
  @Input() question!: Inputfiledsbase<string>;
  @Input() form!: FormGroup;
  actiondata:any;

  // Document viewer properties
  isViewingDocument: boolean = false;
  currentDocumentUrl: SafeResourceUrl | null = null;
  currentDocumentType: string | null = null;
  currentDocument: any = null;
  contentname: any = '';
  formcls = {};
  dialogid: any;

  displayedColumns: string[] = [
    'slno',
    'title',
    // 'size',
    'uploadedDate',
    'uploadedBy',
    'status',
    'type',
    'actions',
  ];

  constructor(
    private eContentFormQuestions: EcontentServicesService,
    private qcs: QuestionControlService,
    private apiServices: ApiservicesService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private router: Router,
    private toast: ToastService,
    private permissionService: PermissionService,
  ) {

   }

  ngOnInit(): void {
    this.actiondata = this.permissionService.getactiondata();
    this.route.paramMap?.subscribe((params) => {
      this.coursesId = params.get('courseId')!;
      this.selectedSemester = params.get('semesterId')!;
      this.selectedSubject = params.get('subjectId')!;
      this.selectesSubjectName = params.get('subjectName')!;
      this.formcls = {
        courseId: this.coursesId,
        semesterId: this.selectedSemester,
        subjectId: this.selectedSubject
      }
      this.loadDocuments();
    });

    this.eContentFormQuestions.showecontentdocform().subscribe((questions) => {
      this.questions = questions;
      this.form = this.qcs.toFormGroup(questions);
    });
  }

  loadDocuments(): void {
    this.apiServices
      .getEcontentSubjectDocList(
        this.coursesId,
        this.selectedSemester,
        this.selectedSubject
      )
      .subscribe({
        next: (res: any) => {
          this.documents = res?.data ?? [];
        },
        error: (err) => console.error(err),
      });
  }

  openAddDialog(templateRef: TemplateRef<any>, id: number, name: string): void {
    this.dialogid = id;
    const data = {
      'econtent_title': name
    }
    // this.form.patchValue(data);
    this.dialogRef = this.dialog.open(templateRef,
      { width: '600px' });

    this.dialogRef.afterOpened().subscribe(() => {
      this.form.patchValue(data);
    });
  }

  closeDialog(): void {
    this.dialogRef?.close();
    this.resetFileUpload();
  }

  handleAction(action: string, documentId: number, name: any, status: string): void {
    this.contentname = name;
    switch (action) {
      case 'view':
        this.viewDocument(documentId);
        break;
      case 'edit':
        this.editDocument(documentId, status);
        break;
      case 'delete':
        this.deleteDocument(documentId);
        break;
    }
  }

  viewDocument(documentId: number): void {
    this.currentDocument = this.documents.find((doc) => doc.id === documentId);
    if (!this.currentDocument || !this.currentDocument.url) {
      console.warn('Document or URL not found');
      return;
    }

    this.currentDocumentType = this.getDocumentType(this.currentDocument.url);
    const fullUrl = this.getFullDocumentUrl(this.currentDocument.url);

    if (this.currentDocumentType === 'pdf') {
      this.currentDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://docs.google.com/gview?url=${encodeURIComponent(
          fullUrl
        )}&embedded=true`
      );
    } else if (
      this.currentDocumentType === 'word' ||
      this.currentDocumentType === 'excel' ||
      this.currentDocumentType === 'powerpoint'
    ) {
      this.currentDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          fullUrl
        )}`
      );
    } else if (this.currentDocumentType === 'image') {
      this.currentDocumentUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
    } else if (this.currentDocumentType === 'mp4') {
      this.currentDocumentUrl = fullUrl;
    }

    this.isViewingDocument = true;
  }

  backToList(): void {
    this.isViewingDocument = false;
    this.currentDocumentUrl = null;
    this.currentDocumentType = null;
    this.currentDocument = null;
    this.contentname = '';
  }

  downloadDocument(): void {
    if (!this.currentDocument?.url) return;

    const fullUrl = this.getFullDocumentUrl(this.currentDocument.url);
    const link = document.createElement('a');
    link.href = fullUrl;
    link.download = this.currentDocument.title || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private getDocumentType(url: any): string {
    if (!url) return 'unknown';

    const extension = url.split('.').pop()?.toLowerCase() || '';

    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
      return 'image';
    } else if (extension === 'pdf') {
      return 'pdf';
    } else if (['doc', 'docx'].includes(extension)) {
      return 'word';
    } else if (['xls', 'xlsx'].includes(extension)) {
      return 'excel';
    } else if (['ppt', 'pptx'].includes(extension)) {
      return 'powerpoint';
    } else if (['mp4', 'video'].includes(extension)) {
      return 'mp4';
    } {
      return 'unknown';
    }
  }

  private getFullDocumentUrl(relativeUrl: string): string {
    if (!relativeUrl) return '';

    if (relativeUrl.startsWith('http')) {
      return relativeUrl;
    }

    return `${this.apiServices.environmentPath}/${relativeUrl}`;
  }

  editDocument(documentId: number, value: string): void {
    let pubstatus = '';
    if (value == 'UNPUBLISHED') {
      pubstatus = 'PUBLISHED';
    } else {
      pubstatus = 'UNPUBLISHED';
    }
    const flag = confirm(`Are you sure you want to ${pubstatus}`);
    if (flag) {
      const body = {
        "status": pubstatus
      }
      this.apiServices.updateEcontent(documentId, body).subscribe((res) => {
        if (res.status == true) {
          this.loadDocuments();
          this.toast.showToast('success', `E-content ${pubstatus} successfully!`);
        } else {
          console.warn(res.message);
        }
      });
    }
  }

  deleteDocument(documentId: number): void {
    this.apiServices.deleteEContentDocumentData(documentId).subscribe((res) => {
      if (res.code === '202') {
        this.loadDocuments();
        this.toast.showToast('success', 'E-content deleted successfully!');
      } else {
        console.warn(res.message);
      }
    });
  }

  resetFileUpload(): void {
    this.filePreview = null;
    this.fileName = null;
    this.isImage = false;
  }

  onSubmit(): void {
    if (this.form.valid) {

      // const formData = new FormData();
      // formData.append('title', this.form.value['econtent_title']);
      // formData.append('course_id', this.coursesId);
      // formData.append('semester_id', this.selectedSemester);
      // formData.append('subject_id', this.selectedSubject);
      // formData.append('category_id', this.documents[0]?.category_id || 195);
      const body = {
        "title": this.form.value['econtent_title']
      }
      this.apiServices.updateEcontent(this.dialogid, body).subscribe(
        {
          next: (res: any) => {
            if (res.status == true) {
              this.loadDocuments();
              this.closeDialog();
              this.toast.showToast('success', 'Title edited successfully!');
            } else {
              console.warn('Unexpected response code:', res.message);
            }
          },
          error: (err) => console.error('API Error:', err),
        }
      );

      // if (this.fileToUpload) {
      //   formData.append('econtent_media', this.fileToUpload);
      // }

      // this.apiServices.createEContentData(formData).subscribe({
      //   next: (res: any) => {
      //     if (res.code === 201) {
      //       this.loadDocuments();
      //       this.closeDialog();
      //     } else {
      //       console.warn('Unexpected response code:', res.message);
      //     }
      //   },
      //   error: (err) => console.error('API Error:', err),
      // });

    } else {
      console.warn('Form is invalid');
    }
  }

  getFileTypeIcon(fileType: string): string {
    if (!fileType) return 'attach_file_add';

    const type = fileType.toLowerCase();

    if (type.includes('pdf')) return 'picture_as_pdf';
    if (type.includes('word') || type.includes('doc')) return 'description';
    if (type.includes('excel') || type.includes('xls')) return 'table_chart';
    if (type.includes('powerpoint') || type.includes('ppt')) return 'slideshow';
    if (
      type.includes('image') ||
      type.includes('jpg') ||
      type.includes('jpeg') ||
      type.includes('png') ||
      type.includes('gif')
    )
      return 'image';
    if (type.includes('text') || type.includes('txt')) return 'text_snippet';
    if (type.includes('video')) return 'movie';
    if (type.includes('mp4')) return 'movie';
    if (type.includes('audio')) return 'audiotrack';
    if (type.includes('zip') || type.includes('rar') || type.includes('7z'))
      return 'folder_zip';

    return 'attach_file_add';
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileToUpload = input.files[0];
      this.fileName = this.fileToUpload.name;
      this.isImage = this.fileToUpload.type.startsWith('image/');
      if (this.isImage) {
        const reader = new FileReader();
        reader.onload = () => {
          this.filePreview = reader.result as string;
        };
        reader.readAsDataURL(this.fileToUpload);
      } else {
        this.filePreview = null;
      }
    }
  }

  navigateToBackPage(): void {
    window.history.back();
  }

  addecontent() {
    this.eContentFormQuestions.setshowform(true);
    this.eContentFormQuestions.setformcls(this.formcls);
    this.router.navigate(['./e-content']);
  }
}
